/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespPriceNegotiationToastLoader_displayInfo$ref = any;
type PdpRespSidebarBlurbs_displayInfo$ref = any;
type PdpRespSidebarButtons_displayInfo$ref = any;
type PdpRespSidebarContact_displayInfo$ref = any;
type PdpSharedPromoCode_displayInfo$ref = any;
type PriceDisplay_displayInfo$ref = any;
export type PdpRespContainer_displayInfo$ref = any;
export type PdpRespContainer_displayInfo = {
    readonly " $fragmentRefs": PdpRespSidebarButtons_displayInfo$ref & PdpRespSidebarContact_displayInfo$ref & PdpSharedPromoCode_displayInfo$ref & PdpRespSidebarBlurbs_displayInfo$ref & PriceDisplay_displayInfo$ref & PdpRespPriceNegotiationToastLoader_displayInfo$ref;
    readonly " $refType": PdpRespContainer_displayInfo$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_displayInfo",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_displayInfo",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_displayInfo",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_displayInfo",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PriceDisplay_displayInfo",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "PdpRespPriceNegotiationToastLoader_displayInfo",
          "args": null
        }
      ]
    }
  ]
};
(node as any).hash = '4582fcfc07c302365f73bd110eb3a13e';
export default node;
